import { Cartridge } from 'types';
import { createSelector } from '@reduxjs/toolkit';
import { i18n } from '@lingui/core';
import { keyBy } from 'lodash';
import type { RootState } from 'store/redux';
import { api } from './api';

export const roles: string[] = [];

export type DictValue<T = {}> = T & {
  Code: string;
  Name: string;
};

export interface Timezone {
  abbreviation: string;
  dst: boolean;
  dst_from: null;
  dst_until: null;
  dst_offset: number;
  raw_offset: number;
  timezone: string;
  utc_offset: string;
}

type Tank = {
  // Высота
  h: number;
  // Ширина
  w: number;
  // Глубина
  l: number;
  // Объём на самом деле для танков сохраненное значение которых не совпадает с тем какой объем имеется
  actualVolume: number;
  // Человекопонятное название
  label?: string;
};

export interface Dicts {
  currency: DictValue<{ Sign: string }>[];
  devicetype: DictValue[];
  logfilters: DictValue[];
  mobileoperators: DictValue[];
  roles: Array<{ GroupName: string }>;
  countrycodes: Array<{ Name: string; Value: string }>;
  timezones: Timezone[];
  cartridges: Record<string, Cartridge>;
  mainboards: Array<{ Name: string; Value: number }>;
  tanks: Record<string, Tank>;
  fiscal: DictValue[];
}

export const configService = api
  .enhanceEndpoints({ addTagTypes: ['Config'] })
  .injectEndpoints({
    endpoints: (build) => ({
      all: build.query<Dicts, string>({
        query: (locale: string) => ({
          url: `/catalog/*`,
          params: { locale },
          method: 'GET'
        }),
        keepUnusedDataFor: 0,
        providesTags: ['Config']
      })
    })
  });

export const selectCurrencies = createSelector(
  (state: RootState) => state,
  (state) => {
    const { data } = configService.endpoints.all.select(i18n.locale)(
      state as any
    );

    return keyBy(data?.currency, 'Code');
  }
);

export const selectTanks = createSelector(
  (state: RootState) => state,
  (state) => {
    const { data } = configService.endpoints.all.select(i18n.locale)(
      state as any
    );

    return data?.tanks;
  }
);
